import InlineFormatToolbar from './InlineFormatToolbar';

export default InlineFormatToolbar;
